export default __webpack_public_path__ + "static/media/MagicalStringsGroup_orig.3f156e24.jpg";